var imagePath = 'https://yakima-production.s3.amazonaws.com/fmc/';
var rootPath = window.location.href;
var apiUrl = 'https://go.yakima.com/api';
var roofTypeIds = [];
var roofTypeNames = [];
var currentSku = '';
var pageLoaded = false;
var discountAmount = 0;
var activeFit = localStorage.getItem('fitId');
var containsRuggedLine = false;

if (rootPath.indexOf('www.yakima.com') >= 0)
    rootPath = 'https://www.yakima.com';


jQuery(document).ready(function ($) {


    currentSku = $('.sku').first().text().replace('SKU: #', '');
  //  localStorage.setItem('system-name', jQuery('.product-single__title').first().text().replace(' System', ''));
    showTowerSystem();

    if(window.location.href.indexOf('showCart=1') >= 0) {
       jQuery('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
       removeQueryStringFromUrl();
    }
  
    pageLoaded = true;
   // document.addEventListener("limoniapps:discountninja:product:discountapplied", function (event) { var discountedProductInfo = event.detail.data[0]; console.log('Product discounted', discountedProductInfo); window.setTimeout(calculateDiscounts, 500);  });
    window.setTimeout(calculateDiscounts, 2000);
});
function removeQueryStringFromUrl() {
  const url = new URL(window.location.href);
  url.search = '';
  window.history.replaceState({}, document.title, url.toString());
}
function getPriceText(price) {
    return '$' + parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function showTowerSystem() {
    var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
    var isLNL = window.location.href.indexOf('locknload') > 0;
    var isRuggedLine = window.location.href.indexOf('ruggedline') > 0;
    var isRibCage = window.location.href.indexOf('ribcage') > 0;
    var isFX = window.location.href.indexOf('-fx-') > 0;
    var isHD = window.location.href.indexOf('overhaul') > 0 || window.location.href.indexOf('outpost') > 0 || window.location.href.indexOf('bedrock') > 0;
    var isFlushRail = window.location.href.indexOf('flushbar') > 0 || window.location.href.indexOf('railbar') > 0;
    var showCrossbars = true;
    var jetstreamPrice = 270;
    var hdPrice = 319;
    var corePrice = 200;
    var roundPrice = 130;
    var adapterPrice = 30;
    var roundbarOnly = false;
    var stepCnt = 1;

    if (localStorage.getItem('ipCountry') == 'ca') {
        jetstreamPrice = 349.99;
        hdPrice = 499.99;
        corePrice = 279.99;
        roundPrice = 199.99;
        adapterPrice = 55.99;
    }
    jQuery('.price-box .price').each(function () {
        jQuery(this).text('Starting at ' + jQuery(this).text());
    });
    if (isLNL && !localStorage.getItem('attach'))
    {
          localStorage.setItem('attach', 'bar');
         
    }
    hideBars();

    setCurrentFit();
    jQuery('.tower-options').html('');
    if (isLNL) {
        if (localStorage.getItem('isTruck') == 'true') {
            jQuery('.tower-options').append('<div class="tower-truck systems-fit-options--top"><h4>Platform Location</h4></div>');
            var cls = '';
            if (localStorage.getItem('noRoofFit') == 'true')
                cls = ' disabled';
            jQuery('.tower-options .tower-truck').append('<div id="truck-roof" class="system-fit-options--option truck' + cls + '" data-id="truck-roof">Truck Cab</div>');
            jQuery('.tower-options .tower-truck').append('<div id="truck-truckbed" class="system-fit-options--option truck" data-id="truck-bed">Truck Bed</div>');

        }
        else
            localStorage.removeItem('truck-placement');
      //  jQuery('.tower-options').append('<div class="tower-attachment"><h4>Platform Attachment Method</h4><p>The LockNLoad Platform can be attached two ways; either to your crossbars or roof rack towers. <a href="https://yakima-production.s3.amazonaws.com/docs/LockNLoad_Attachment.pdf" target="_blank">Learn More</a></p></div>');

        var attachmentSelect = '<div id="attachment-section" class="tower-attachment"><div class="systems-fit-options--top"><h4 class="systems-fit-options--title">1. Pick Your Attachment Method</h4><a href="https://yakima-production.s3.amazonaws.com/docs/LockNLoad_Attachment.pdf" class="underline text-lg underline-offset-2" target="_blank">Learn More</a></div>';
        if(localStorage.getItem('vehicleId') != null && localStorage.getItem('vehicleId') != '0')
           attachmentSelect += '<div class="system-fit-options--bottom"><div id="attachment-bar" class="system-fit-options--option">Attach to Crossbars</div><div id="attachment-tower" class="system-fit-options--option">Attach to Towers</div></div></div>';
        jQuery('.tower-options').append(attachmentSelect);
      stepCnt++;

    if (!localStorage.getItem('attach'))
        localStorage.setItem('attach', 'bar');

        jQuery('.tower-options').append('<div class="tower-type" style="display: none;"><h4>Tower Type</h4><p>Your vehicle supports multiple tower options, please select the most appropriate.</p></div>');
        
       
    }
  else if(isRibCage) {
     jQuery('.tower-options').append('<div class="tower-type" style="display: none;"><h4>Tower Type</h4><p>Your vehicle supports multiple tower options, please select the most appropriate.</p></div>');
        
  }
   
    if (isFlushRail) {
        jQuery('.tower-options').append('<div id="fitCurrentVehicle"></div><div id="crossbar-section"><h4>Select a Crossbar Color</h4></div>');
        jQuery('#crossbar-section').append('<div id="bar-black" class="bar-option bar"><img src="' + imagePath + 'railbar-black.jpg"/><h4>Black Crossbars</h4><h4 class="price"></h4></div>');
        jQuery('#crossbar-section').append('<div id="bar-silver" class="bar-option bar"><img src="' + imagePath + 'railbar-silver.jpg"/><h4>Silver Crossbars</h4><h4 class="price"></h4></div>');
        jQuery('.tower-options').append('<div class="tower-bar-length"><h4>Select Crossbar Length</h4><p><a href="">Which crossbar length is right for you?</a></p></div>');

    }
    else if (window.location.href.indexOf('outdoorsman') > 0) {
        jQuery('.tower-options').append('<div id="outdoorsman-size"><h4>Outdoorsman Size</h4></div>');
        jQuery('#outdoorsman-size').append('<div id="outdoorsman-compact" class="bar-option outdoorsman"><img src="' + imagePath + 'outdoorsman-300.png"/><h4>Compact</h4><h4 class="price">' + getPriceText(roundPrice + adapterPrice) + '</h4></div>');
        jQuery('#outdoorsman-size').append('<div id="outdoorsman-fullsize" class="bar-option outdoorsman"><img src="' + imagePath + 'outdoorsman_fullsize.png"/><h4>Fullsize</h4><h4 class="price">' + getPriceText(roundPrice + adapterPrice) + '</h4></div>');
        jQuery('.tower-options').append('<div class="tower-bar-length"></div>');
        roundbarOnly = true;
        loadBarSizes("RoundBar");
    }
    else if (window.location.href.indexOf('raingutter') > 0) {
        jQuery('.tower-options').append('<div class="tower-bar-length"></div>');
        roundbarOnly = true;
        loadBarSizes("RoundBar");
    }
    
   else if (!isFX) {

    var barType = '';
     if(localStorage.getItem('bar-type') != null) {
       barType = localStorage.getItem('bar-type');
     }
    
      
     
      if (!isHD) {
         var crossbarSelect = '<div id="crossbar-section"><div class="systems-fit-options--top flex items-center justify-start gap-y-1 gap-x-12 flex-wrap"><h4 class="systems-fit-options--title">' + stepCnt + '. Pick Your Crossbar Style</h4><a href="https://yakima.com/pages/crossbar-basics" class="underline text-lg underline-offset-2" target="_blank">Learn More</a></div>';
        if(localStorage.getItem('vehicleId') != null && localStorage.getItem('vehicleId') != '0')
         crossbarSelect += '<div class="system-fit-options--bottom" id="bar-types"><div id="bar-jetb" class="system-fit-options--option' + (barType.indexOf('JetStream') >= 0 ? ' selected' : '') + '">JetStream</div><div id="bar-hd" class="system-fit-options--option' + (barType == 'HD Bar' ? ' selected' : '') + '">HD Bar</div><div class="system-fit-options--option' + (barType == 'CoreBar' ? ' selected' : '') + '">CoreBar</div><div id="bar-round" class="system-fit-options--option' + (barType == 'RoundBar' ? ' selected' : '') + '">RoundBar</div></div></div>';
        stepCnt++;
        if(localStorage.getItem('vehicleId') != null && localStorage.getItem('vehicleId') != '0') {
          var colorSelect = '<div id="jetstream-color" class="' + ((barType.length == 0 || barType.indexOf('JetStream') < 0) ? 'hidden' : '') + '" ><div class="systems-fit-options--top"><h4 class="systems-fit-options--title">Pick your JetStream Color</h4></div>';
          if(localStorage.getItem('vehicleId') != null && localStorage.getItem('vehicleId') != '0')
           colorSelect += '<div class="system-fit-options--bottom" id="bar-colors"><div id="bar-color-black" class="system-fit-options--color ' + (barType == '' || barType.indexOf('Black') >= 0 ? ' selected' : '') + '"><span class="system-fit-options--color-color bg-black"></span><span>Black</span></div><div id="bar-color-silver" class="system-fit-options--color' + (barType.indexOf('Silver') >= 0 ? ' selected' : '') + '"><span class="system-fit-options--color-color bg-lt-gray"></span><span>Silver</span></div></div></div>';
        }
        
        jQuery('.tower-options').append(crossbarSelect);
        jQuery('.tower-options').append(colorSelect);
      }
     else 
        barType = "HD Bar";

     var sizeSelect = '<div id="crossbarsize-section"><div class="tower-bar-length systems-fit-options--top flex items-center justify-start gap-y-1 gap-x-12 flex-wrap"><h4 class="systems-fit-options--title">' + stepCnt + '. Pick Your Crossbar Length</h4><a href="https://yakima.com/pages/choosing-the-right-crossbar-length" class="underline text-lg underline-offset-2" target="_blank">Learn More</a></div>';
      if(localStorage.getItem('vehicleId') != null && localStorage.getItem('vehicleId') != '0')
         sizeSelect += '<div class="system-fit-options--bottom ' + (localStorage.getItem('bar-type') == null ? ' hidden' : '') + '" id="bar-sizes"><div class="system-fit-options--option">48"</div><div class="system-fit-options--option">58"</div><div class="system-fit-options--option">66"</div><div class="system-fit-options--option">78"</div></div></div>';
stepCnt++;
      jQuery('.tower-options').append(sizeSelect);

     if(barType.length > 0) loadBarSizes(barType);
       if(isLNL || isRuggedLine) {
        var platformSelect = '<div id="platform-section" class="tower-platform-size"><div class="systems-fit-options--top"><h4 class="systems-fit-options--title">' + stepCnt + '. Pick Your Platform Size</h4><a href="https://assets.yakima.com/product/instructions/8005044/1" class="underline text-lg underline-offset-2" target="_blank">Learn More</a></div>';
        var pf = localStorage.getItem('platformSize');
        if(localStorage.getItem('vehicleId') != null && localStorage.getItem('vehicleId') != '0') {
         platformSelect += '<div class="system-fit-options--bottom ' + (isRuggedLine || localStorage.getItem('bar-size') == null ? ' hidden' : '') + '"><div class="system-fit-options--option' + (pf == '8005044' ? ' selected' : '') + '" data-sku="8005044">55"x49"</div><div class="system-fit-options--option' + (pf == '8005045' ? ' selected' : '') + '" data-sku="8005045">60"x54"</div><div class="system-fit-options--option' + (pf == '8005046' ? ' selected' : '') + '" data-sku="8005046">76"x54"</div><div class="system-fit-options--option' + (pf == '8005063' ? ' selected' : '') + '" data-sku="8005063">76"x65"</div><div class="system-fit-options--option' + (pf == '8005047' ? ' selected' : '') + '" data-sku="8005047">84"x49"</div><div class="system-fit-options--option' + (pf == '8005048' ? ' selected' : '') + '" data-sku="8005048">84"x54"</div><div class="system-fit-options--option' + (pf == '8005049' ? ' selected' : '') + '" data-sku="8005049">84"x62"</div></div></div>';
       //   platformSelect += '<div class="system-warning"><p>Verify your vehicles weight rating before ordering.</p><a href="https://assets.yakima.com/product/instructions/8005044/3" target="_blank">Learn More</a></div>';  
       }
        jQuery('.tower-options').append(platformSelect);
        setPlatform();
     }
    }
  jQuery('.tower-options').append('<div class="tower-count " id="towerCount" style="display: none;"><h4 >Optional Third Tower</h4><p>This vehicle can support an optional third set of towers, which will increase the weight limit of your system by up to 110 pounds (depending on vehicle and crossbar/platform rating).  </p><p><input class="check" type="checkbox" id="thirdTower" name="thirdTower" value="">Add Third Tower and Crossbar to Cart</p></div>');

    if (localStorage.getItem('hasTonneau') == 'true' && (window.location.href.indexOf('overhaul-hd-system') >= 0 || window.location.href.indexOf('outpost-hd-system') >= 0)) {
        jQuery('.tower-options').append('<div class="tonneau-type clear systems-fit-options--top"><h4 class="systems-fit-options--title">' + stepCnt + '. Select Tonneau Cover</h4><p><i>Note: only certain tonneau covers are compatible with the ' + jQuery('h1.product-single__title').first().text() + '</i></p></div><div id="tonneau-types" class="system-fit-options--bottom"></div>');

        var url = apiUrl + '/tonneau/GetTonneaus/' + localStorage.getItem('vehicleId');
        jQuery.get(url, function (data) {

            jQuery.each(data, function (i, e) {
                jQuery('.tower-options #tonneau-types').append('<div id="tonneau-' + e.id + '" data-id="' + e.tonneauKitId + '" class="tonneau system-fit-options--option"><h4>' + e.tonneauName + '</h4></div>');

            });
                jQuery('.tower-options #tonneau-types').append('<div id="tonneau-0" data-id="0" class="tonneau system-fit-options--option"><h4>Other</h4></div>');

            bindOptionSelect();
        });

    }

    //  jQuery('.tower-config').html('<h3>Customize Your ' + localStorage.getItem('system-name') + ' System</h3>');
  var systemName = jQuery('.product-single__title').first().text().replace(' System', '');
      jQuery('.tower-options').append('<div class="system-summary limoniapps-discountninja-cart-root' + (!isRuggedLine && !isFX && localStorage.getItem('attach') != 'tower' && localStorage.getItem('bar-type') == null ? ' hidden' : '') + '"><h3>Order Summary</h3><div class="content"></div>');
    jQuery('.tower-options .system-summary .content').append('<div id="selected-bar" class="bar-options section"></div>');
  
    jQuery('.tower-options .system-summary .content').append('<h4>Parts Required For Assembly:</h4> <div class="required-items section"></div>');
    jQuery('.tower-options .system-summary .content').append('<div id="system-conditionals" style="display: none;"><h4>Conditional Items</h4><div class="conditional-items section"></div></div>');
    jQuery('.tower-options .system-summary .content').append('<div class="system-total section"></div>');
    jQuery('.tower-options .system-summary .content .system-total').append('<span class="total label">Total</span><span class="total value"></span><span class="total totalprice "></span>');
      jQuery('.tower-options .system-summary .content').append('<button type="button" title="Add to Cart" class="button btn-cart-force" id="tower-add-cart"><span><span>Add to Cart</span></span></button><div class="clear"></div>');

  
    jQuery('.tower-options .system-summary .content').append('<div id="out-of-stock" style="display: none;"><h4 class="title">Out of Stock Items Required for Assembly:</h4><span class="oos-parts"></span><div class="buttons"><a id="bis-notify" class="btn notify BIS_trigger" href="#">Notify Me</a><a class="btn dealer" href="/pages/dealer-locator">Find a Dealer</a></div></div>');
    var vehicleId = localStorage.getItem('vehicleId');
    if (vehicleId == null || vehicleId == 0) {
        jQuery('.tower-options .system-summary').hide();
       // jQuery('.product-single .tower-options').first().prepend('<button type="button" title="Add Vehicle" class="button btn" id="tower-add-vehicle" onclick="fmcModalInit()"><span><span>Add Vehicle</span></span></button><div class="clear"></div>');
    }
    if (roundbarOnly) {
        jQuery('.system-summary .bar-options h4').first().text('RoundBar');
        jQuery('.system-summary .bar-options img').first().attr('src', imagePath + 'roundbar.png');
        jQuery('.system-summary .bar-options span.price').first().html(getPriceText(roundPrice));
        jQuery('.system-summary .bar-options a').first().hide();
    }
    if (isHD) {
        jQuery('.system-summary .bar-options h4').first().text('HD Bar');
        jQuery('.system-summary .bar-options img').first().attr('src', imagePath + 'hdbar.png');
        jQuery('.system-summary .bar-options span.price').first().html(getPriceText(hdPrice));
        jQuery('.system-summary .bar-options a').first().hide();
    }
    calculateTotals();

    bindOptionSelect();
    fitCheck();

    jQuery('#crossbar-section').show();
    if (isHD) {
        jQuery('#crossbar-section').hide();
        jQuery('#jetstream-color').hide();
    }
    if (isFlushRail)
        jQuery('.tower-bar-length').hide();

    if (localStorage.getItem('truck-placement') == 'truck-roof')
        jQuery('#truck-roof').click();
    if (localStorage.getItem('truck-placement') == 'truck-bed')
        jQuery('#truck-truckbed').click();

    if (localStorage.getItem('attach'))
        jQuery('#attachment-' + localStorage.getItem('attach')).click();
    if (localStorage.getItem('tower-bartype'))
        jQuery('#' + localStorage.getItem('tower-bartype')).click();
    if (localStorage.getItem('tower-barsize')) {
        jQuery('#' + localStorage.getItem('tower-barsize')).click();
    }
    jQuery('#tower-add-cart').click(function () {
        addToCart();
    });



}
function hideBars() {
    var truckSystems = 'OverHaul HD,OutPost HD,BedRock HD,Outdoorsman 300,Outdoorsman 300 Fullsize';
    var isLNL = window.location.href.indexOf('locknload') > 0 || window.location.href.indexOf('ruggedline') > 0;
    var isRuggedLine = window.location.href.indexOf('ruggedline') > 0;
  var systemName = jQuery('.product-single__title').first().text().replace(' System', '');
    roofSystem = truckSystems.indexOf(systemName) < 0;

    jQuery('.product-single').first().removeClass('hideBars');

    var isHD = window.location.href.indexOf('overhaul') > 0 || window.location.href.indexOf('outpost') > 0 || window.location.href.indexOf('bedrock') > 0;
    var hdPrice = 249;
    if (isHD || (isLNL && localStorage.getItem('truck-placement') == 'truck-bed' && jQuery('.product-single.hideBars').length == 0 && systemName.indexOf('Outdoorsman') < 0)) {
        jQuery('.system-summary .bar-options h4').first().text('HD Bar');
        jQuery('.system-summary .bar-options img').first().attr('src', imagePath + 'hdbar.png');
        jQuery('.system-summary .bar-options span.price').first().text(getPriceText(hdPrice));
        jQuery('.system-summary .bar-options a').first().hide();
        jQuery('#bar-hd').click();
        jQuery('#crossbar-section').hide();
    }
    else
        jQuery('#crossbar-section').show();

    if(isRuggedLine) {
        jQuery('#crossbar-section').first().hide();
        jQuery('.bar-option').hide();
        jQuery('.tower-bar-length').hide();
        jQuery('#selected-bar').hide();
      }
}
function setCurrentFit() {
    var truckSystem = window.location.href.indexOf('overhaul') > 0 || window.location.href.indexOf('outpost') > 0 || window.location.href.indexOf('bedrock') > 0 || window.location.href.indexOf('outdoorsman') > 0;
    var rooftypeId = localStorage.getItem('rooftypeId');
    var isLNL = window.location.href.indexOf('locknload') > 0;
    var isRibCage = window.location.href.indexOf('ribcage') > 0;
    var isRuggedLine = window.location.href.indexOf('ruggedline') > 0;
    var noFit = localStorage.getItem('fitId') == 'null' || localStorage.getItem('fitId') == '0' || localStorage.getItem('fitId') == '-3';
    if (truckSystem || localStorage.getItem('truck-placement') == 'truck-bed')
        rooftypeId = 16;
      if(isRuggedLine) {
          jQuery('#crossbar-section').first().hide();
          jQuery('.bar-option').hide();
          jQuery('.tower-bar-length').hide();
          jQuery('#selected-bar').hide();
        }
  
    if (localStorage.getItem('vehicleId') && localStorage.getItem('rooftypeId')) {
        var url = apiUrl + '/fit/getFits/US/' + localStorage.getItem('vehicleId') + '/' + rooftypeId + '/false/false/false/false/false/0/false/false/false';
      if(window.location.href.indexOf('preview=1') > 0) {
        url = apiUrl + '/fit/getFits/US/' + localStorage.getItem('vehicleId') + '/' + rooftypeId + '/false/false/false/false/false/0/false/false/true';
      }
        console.log(url);
        jQuery.get(url, function (data) {
            jQuery('#attachment-tower').removeClass('disabled');
            if (typeof data == 'object') {
                console.log(data);
                localStorage.removeItem('towerSystemId');
                localStorage.removeItem('systemId');
                var towerSystemId = 0;
                var barSystemId = 0;
                if(isRuggedLine) {
                       jQuery('#fitCurrentVehicle').html('<p><span class="dot nofit" style="color: #666;">•</span> We cannot confirm compatibility with your vehicle.</p>');
                  
                   jQuery.each(data, function (i, e) {
                        if(e.fitTypeId == 47)  {
                          containsRuggedLine = true;
                          localStorage.setItem('ruggedSystemId', e.id);
                          localStorage.setItem('systemId', e.id);
                          activeFit = e.id;
                          
                        jQuery('#shopify-section-system-template .product-single').addClass('hideBars');
                          enableCart();

                          setRequiredItems();
                          jQuery('#tower-add-cart').removeClass('disabled');
                          
                          var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
                          jQuery('#fitCurrentVehicle').html('<p><span class="dot fit" style="color: #64a70b;"></span>  Fits your ' + vehName + '</p>');
                        }
                   });
                }
                else if (isLNL) {
                 //   if (noFit || localStorage.getItem('system-name') == 'SkyLine' || localStorage.getItem('system-name') == 'TimberLine') {
                      console.log('finding locknload system');
                        towerSystemId = findSystem(data, 'locknload');
                        localStorage.setItem('towerSystemId', towerSystemId);
                      //  localStorage.setItem('attach', 'rugged');
                      
                   // }
                    if (towerSystemId == 0)
                        jQuery('#attachment-tower').addClass('disabled');
                    else
                        jQuery('#attachment-tower .pill').hide();
                  
                    var roofSystem = false;
                    var truckSystems = 'OverHaul HD,OutPost HD,BedRock HD,Outdoorsman 300,Outdoorsman 300 Fullsize';
                   var systemName = jQuery('.product-single__title').first().text().replace(' System', '');
                    roofSystem = truckSystems.indexOf(systemName) < 0;
                    if (localStorage.getItem('truck-placement') == 'truck-bed') {
                        if (barSystemId == 0 && (noFit || roofSystem || systemName == 'OverHaul HD')) barSystemId = findSystem(data, 'overhaul-hd');
                        if (barSystemId == 0 && (noFit || roofSystem || systemName == 'OutPost HD')) barSystemId = findSystem(data, 'outpost-hd');
                        if (barSystemId == 0 && (noFit || roofSystem || systemName == 'BedRock HD')) barSystemId = findSystem(data, 'bedrock-hd');
                        if (barSystemId == 0 && (noFit || roofSystem || systemName == 'Outdoorsman 300')) barSystemId = findSystem(data, 'outdoorsman-300');
                    }
                  console.log('finding fit', noFit, roofSystem, systemName);
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'SkyLine FX')) barSystemId = findSystem(data, 'skyline-fx');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'SkyLine')) barSystemId = findSystem(data, 'skyline');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'SightLine')) barSystemId = findSystem(data, 'sightline');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'TimberLine')) barSystemId = findSystem(data, 'timberline');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'TimberLine FX')) barSystemId = findSystem(data, 'timberline-fx');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'BaseLine FX')) barSystemId = findSystem(data, 'baseline-fx');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'BaseLine')) barSystemId = findSystem(data, 'baseline');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'RidgeLine')) barSystemId = findSystem(data, 'ridgeline');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == '1A Raingutter')) barSystemId = findSystem(data, 'raingutter');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'TrackTower')) barSystemId = findSystem(data, 'tracktower');
                    if (barSystemId == 0 && (noFit || !roofSystem || systemName == 'RibCage')) barSystemId = findSystem(data, 'ribcage');
                    if (barSystemId > 0)
                        jQuery('#attachment-bar .pill').hide();
                   
                  console.log('barsystemid', barSystemId);
                          localStorage.setItem('systemId', barSystemId);
                    jQuery.each(data, function (i, e) {
                        if(e.fitTypeId == 47)  {
                              containsRuggedLine = true;
                            if(jQuery('#attachment-rugged').length == 0) {
                              jQuery('.tower-options .tower-attachment .system-fit-options--bottom').append('<div id="attachment-rugged" class="system-fit-options--option attach" data-id="attach-rugged">Attach with RuggedLine HD</div>');
                            }
                          localStorage.setItem('ruggedSystemId', e.id);
                          }
                        if (typeof e.Id !== 'undefined' && (e.fitTypeId == 33 || e.fitTypeId == 34 || e.fitTypeId == 44)) {
                          var visible = false;
                          if(e.Name.indexOf("LockNLoad") >= 0 && localStorage.getItem('attach') == 'tower') visible = true;
                          if(e.Name.indexOf("LockNLoad") < 0 && localStorage.getItem('attach') == 'bar') visible = true;
                          
                          if((e.fitTypeId == 44 && e.name.indexOf("LockNLoad") < 0) || e.name.indexOf('RibCage') >= 0)
                          { 
                            // Don't show RibCage or non-LockNLoad TrackTower
                          }
                          else {
                            jQuery('.tower-options .tower-type').append('<div id="attachment-'+ e.id + '" class="bar-option fittype ' + (e.name.indexOf("LockNLoad") >= 0 ? ' lnl' : '') + '" data-id="fit-' + e.id + '" ' + (visible ? '' : ' style="display: none;"') + '><h4>' + e.name.replace(' With LockNLoad', '') + '</h4><img src="https://yakima-production.s3.amazonaws.com/fmc/' + e.img + '"/><p></p></div>');

                             var url = apiUrl + '/fitnote/GetFitNotes/' + e.id;
                            jQuery.get(url, function (data) {
                                jQuery.each(data, function (i, n) {
                                  if(n.id == 428 || n.id == 429)
                                    jQuery('#attachment-' + e.id + ' p').text(n.note);
                                });
                            });
                          }
                          if(jQuery('.tower-options .tower-type .bar-option.lnl:visible').length > 1)
                            jQuery('.tower-options .tower-type').show();
                        }
                    });
                }
                else if (isRibCage) {
                    jQuery.each(data, function (i, e) {
                        
                        if (typeof e.id !== 'undefined') {
                          var cls = '';
                          if (localStorage.getItem('tower-barsize') == 'attachment-' + e.id)
                              cls = ' selected';
                          if(e.name && e.name.indexOf('RibCage') >= 0)  {
                            
                            jQuery('.tower-options .tower-type').append('<div id="attachment-'+ e.id + '" class="bar-option fittype' + cls + '" data-id="fit-' + e.id + '"><h4>' + e.name.replace('RibCage With ', '') + '</h4><img src="https://yakima-production.s3.amazonaws.com/fmc/' + e.name.replace('RibCage With ', '').toLowerCase() + '.png"/><p></p></div>');
                            
                          localStorage.setItem('systemId', e.id);
                          activeFit = e.id;
                setRequiredItems();
                          }
                          
                        }
                    });
                  if(jQuery('.tower-options .tower-type .bar-option').length > 1)
                            jQuery('.tower-options .tower-type').show();
                }
                else {
                    var pname = window.location.href.split("/").pop();
                  	if(pname.indexOf('?') > 0)
                      pname = pname.substring(0, pname.indexOf('?'));
                    barSystemId = findSystem(data, pname.replace('-system', ''));
                    if(barSystemId == 0 && pname == 'tracktower-system')
                      barSystemId = findSystem(data, 'ribcage');
                }
                if (barSystemId > 0) {
                    jQuery.each(data, function (i, e) {
                        if (typeof e.id !== 'undefined') {
                            if (e.id == barSystemId) {
                                activeFit = e.id;
                                localStorage.setItem('systemId', activeFit);
                                var minBarLength = e.minBarLength;
                                if(e.fitTypeId == 39) minBarLength = '1';
                                  localStorage.setItem('crossbarMin', minBarLength);
                                if (window.location.href.indexOf('outdoorsman') > 0) {
                                    if (e.name.indexOf('Compact') > 0)
                                        jQuery('#outdoorsman-fullsize').addClass('disabled');
                                    else
                                        jQuery('#outdoorsman-compact').addClass('disabled');
                                }

                                if (window.location.href.indexOf('overhaul') > 0 || window.location.href.indexOf('outpost') > 0 || window.location.href.indexOf('bedrock') > 0)
                                    loadBarSizes("HD Bar");
                                if (window.location.href.indexOf('raingutter') > 0)
                                    loadBarSizes("RoundBar");

                            }
                        }
                    });
                }
                else {
                    localStorage.removeItem('systemId');
                    activeFit = localStorage.getItem('fitId');
                }
                fitCheck();
                bindOptionSelect();
                setRequiredItems();
            }
          
        });
    }
    else {
      
        fitCheck();
        bindOptionSelect();
        setRequiredItems();
    }
}
  
function findSystem(data, systemName) {
    var id = 0;
    jQuery.each(data, function (i, e) {
        if (typeof e.id !== 'undefined' && id == 0) {
            var fitName = e.img.toLowerCase().replace('.png', '').replace('-(towers-only)', '').replace('-300', '');
            if (systemName == 'locknload' && e.name.toLowerCase().indexOf(systemName) >= 0 && e.name.toLowerCase().indexOf('rugged') < 0)
                id = e.id;
            else if (systemName !== 'locknload' && systemName.indexOf(fitName) >= 0 && systemName.indexOf('-fx') == fitName.indexOf('-fx') && e.name.toLowerCase().indexOf('locknload') < 0 && (e.statusId == 1 || e.statusId == 2))
                id = e.id;
        }
    });
    return id;
}
function loadPlatformSizes() {

    jQuery('.related-products .details').each(function () {
        var name = jQuery(this).find('.name').first().text();
        var sku = jQuery(this).find('.sku').first().text();
        if ((sku.indexOf('800504') == 0 || sku.indexOf('8005063') == 0) && name.toUpperCase().indexOf('PLATFORM') >= 0) {
            var pname = name.replace("LockNLoad ", "").trim();
            var cls = '';
            if (localStorage.getItem('platformSize') == sku)
                cls = ' selected';
            jQuery('.tower-options .tower-platform-size').append('<div id="platform-' + jQuery(this).attr("data-id") + '" class="tower-option platform' + cls + '" data-id="' + jQuery(this).attr("data-id") + '" data-sku="' + sku + '"><div class="pill yellow">Unverified</div><img src="' + jQuery(this).find('.img').first().text() + '"/><h4>' + pname + '</h4></div>');
        }
    });

    jQuery('.tower-options .tower-option').unbind().click(function () {
        if (jQuery('.product-view.nofit').length == 0) {
            jQuery(this).siblings().removeClass('selected');
            jQuery(this).addClass('selected');
            var barName = jQuery(this).find('h4').first().text();
            var platform = barName.split(' ')[1];
              jQuery('.product-single__photos-container').first().html('<img src="' + imagePath + 'locknload_' + platform.toLowerCase() + '.jpg" style="width: 100%;"></img>');
            jQuery('.thumbnails-wrapper').first().html('');
          //  jQuery('.product-media .galleria-stage img').attr('src', imagePath + 'locknload_' + platform.toLowerCase() + '.jpg');
          //  jQuery('.product-media .galleria-carousel .galleria-image').first().addClass('active').find('img').attr('src', imagePath + 'locknload_' + platform.toLowerCase() + '.jpg');
            if (pageLoaded && jQuery(this).find('.red').length == 0) {
                jQuery('body .wrapper .page').first().append('<div id="fmc-modal-container" class="ajax-success-message modal-container active reversed"><div class="ajax-success-message modal-content"><div class="content"><p><b>Warning: The platform size you’ve selected is not guaranteed to fit your vehicle.</b> This configuration has not yet been approved by Yakima. Return to the systems page and select a verified platform size or review Best Practices to confirm a proper fit for your vehicle. </p><div class="actions"><a onclick="closeFMCModal();" class="button reversed close">I Understand</a></div></div></div>');
            }
            localStorage.setItem('platformSize', jQuery(this).attr('data-sku'));
            localStorage.removeItem('tower-bartype');
            localStorage.removeItem('tower-barsize');
            jQuery('.bar-option.bar.selected').removeClass('selected');

            enableCart();
            setRequiredItems();
        }
    });

}
function towerInventory() {

    if (localStorage.getItem('partnerId') === null && localStorage.getItem('ipCountry') != 'ca') {
        jQuery('.tower-options .tower-bar-length .bar-option').each(function () {
            var sku = jQuery(this).attr('data-sku');
            var id = jQuery(this).attr('id');

            if (sku && sku.length > 0) {
              
                var url = apiUrl + '/inventory/GetInventoryValue/' + sku;
                jQuery.get(url, function (data) {
                    if (data <= 0) {
                        jQuery('#' + id).addClass('oos');
                        jQuery('#' + id + ' h4').text('Out of Stock');
                    }
                });
            }

        });
    }

}
function summaryInventory() {
    if (localStorage.getItem('partnerId') === null && localStorage.getItem('ipCountry') != 'ca') {
     // jQuery('#out-of-stock .oos-parts').html('');
      jQuery('#out-of-stock').hide();
      var oositems = ''; //localStorage.getItem('oos-skus');
      if(oositems == null) oositems = '';
        jQuery('.system-summary .required-items .required').each(function () {
          var summaryItem = jQuery(this);
            var sku = jQuery(this).attr('data-sku');
            var id = jQuery(this).attr('data-id');
            var name = jQuery(this).find('h4').text();

            if (sku && sku.length > 0 && sku != '8001151') {
                if(oositems.indexOf(sku) < 0) {
                  var url = apiUrl + '/inventory/GetInventoryValue/' + sku;
                  console.log(url);
                  jQuery.get(url, function (data) {
                      if (data <= 0) {
                          console.log('moving to oos', sku);
                        oositems += sku;
                        localStorage.setItem('oos-skus', oositems);
                                
                       jQuery('#out-of-stock').show();
                       jQuery(summaryItem).first().detach().appendTo(jQuery('#out-of-stock .oos-parts').first());
                      }
                  });
                }
               else {
               jQuery('#out-of-stock').show();
               jQuery(summaryItem).first().detach().appendTo(jQuery('#out-of-stock .oos-parts').first());
               }
                  //jQuery('#bis-notify').attr('data-product-data', '{\"id\":4615330725936,\"handle\":\"baseclip\",\"tags\":[],\"available\":false,\"variants\":[{\"id\":' + id + ',\"title\":\"' + name + '\",\"available\":false,\"inventory_quantity\":0,\"inventory_management\":\"shopify\"},{\"id\":40730529169456,\"title\":\"JetStream\",\"available\":false,\"inventory_quantity\":0,\"inventory_management\":\"shopify\"}]}').attr('data-variant-id', id);
                        
                var variants = '';
                 jQuery('#out-of-stock .oos-parts .required').each(function() {
                    var id = jQuery(this).attr('data-id');
                    var name = jQuery(this).find('h4').text();
                    if(variants.length > 0) variants += ',';
                    variants += '{\"id\":' + id + ',\"title\":\"' + name + '\",\"available\":false,\"inventory_quantity\":0,\"inventory_management\":\"shopify\"}'
                 });
                jQuery('#bis-notify').attr('data-product-data', '{\"id\":4615330725936,\"handle\":\"baseclip\",\"tags\":[],\"available\":false,\"variants\":[' + variants + ']}');
                
                calculateTotals();
              }
          });
      }
}
function bindOptionSelect() {
    var isLNL = window.location.href.indexOf('locknload') > 0;

    jQuery('.system-fit-options--option').unbind().click(function () {
      if(!jQuery(this).hasClass('disabled')) {
        jQuery(this).parent().find('.selected').removeClass('selected');
        jQuery(this).addClass('selected');
        var bartype = jQuery(this).text();
        if(jQuery(this).closest('#crossbar-section').length) {
          if(jQuery(this).attr('id') == 'bar-jetb')  {
            jQuery('#jetstream-color').show();
            jQuery('#bar-colors .selected').removeClass('selected');
            jQuery('#bar-color-black').addClass('selected');
            bartype += ' Black';
          }
          else
            jQuery('#jetstream-color').hide();
  
          localStorage.setItem('bar-type', bartype);
          localStorage.setItem('bar-size', '');
          jQuery('#tower-add-cart').removeClass('disabled').addClass('disabled');
          loadBarSizes(bartype);
         setCrossbar();
          if(isLNL) jQuery('#platform-section .system-fit-options--bottom').first().removeClass('hidden');
          
        }
        if(jQuery(this).closest('#crossbarsize-section').length) {
          localStorage.setItem('bar-size', bartype);
          setCrossbar();
          if(isLNL) jQuery('#platform-section .system-fit-options--bottom').first().removeClass('hidden');
          jQuery('.system-summary.hidden').first().removeClass('hidden');
          jQuery('#tower-add-cart').removeClass('disabled');
        }
       if(jQuery(this).closest('#platform-section').length) {
          localStorage.setItem('selected-platform', bartype);
          localStorage.setItem('platformSize', jQuery(this).attr('data-sku'));
          setPlatform();
         setCrossbar();
          jQuery('.system-summary.hidden').first().removeClass('hidden');
            
        }
        if (jQuery(this).hasClass('tonneau')) {
            localStorage.setItem('tonneauType', jQuery(this).attr('id'));

            if(jQuery(this).attr('id') != '0')
            {
              addRelatedProduct(jQuery(this).attr('data-id'), false, null);
            }
          else {
            jQuery('#tower-add-cart').addClass('disabled');

          }
          fitCheck();
           loadSummary();
        }
      //  loadSummary();
      }
    });
  jQuery('.system-fit-options--color').unbind().click(function () {
      jQuery(this).parent().find('.selected').removeClass('selected');
      jQuery(this).addClass('selected');
      var bartype = 'JetStream ' + jQuery(this).text();
      loadBarSizes(bartype);
      localStorage.setItem('bar-type', bartype);
      setCrossbar();
   //   loadSummary();
    });
  jQuery('#attachment-section .system-fit-options--option').unbind().click(function () {
      if(!jQuery(this).hasClass('disabled')) {
        jQuery(this).parent().find('.selected').removeClass('selected');
        jQuery(this).addClass('selected');
          if (jQuery(this).attr('id') == 'attachment-bar') {
              localStorage.setItem('attach', 'bar');
             // if (localStorage.getItem('fitId') == '0')
                  jQuery('#shopify-section-system-template .product-single').removeClass('hideBars');
            jQuery('.tower-options .tower-type .bar-option').show();
            jQuery('.tower-options .tower-type .bar-option.lnl').hide();
           // jQuery('#jetstream-color').show();
            
          }
          else if (jQuery(this).attr('id') == 'attachment-tower') {
              localStorage.setItem('attach', 'tower');
              jQuery('#shopify-section-system-template .product-single').addClass('hideBars');
            jQuery('.tower-options .tower-type .bar-option').hide();
            jQuery('#platform-section').show();
            localStorage.removeItem('bar-type');
            localStorage.removeItem('bar-size');
          }
        else if (jQuery(this).attr('id') == 'attachment-rugged') {
              localStorage.setItem('attach', 'rugged');
              jQuery('#shopify-section-system-template .product-single').addClass('hideBars');
          jQuery('.product-single__photos').first().html('<img src="http://d2amiavn18tu8z.cloudfront.net/fmc/ruggedline-lnl.jpg"></img>');
        //  jQuery('.tower-platform-size').hide();
          //  jQuery('.tower-options .tower-type .bar-option').hide();
          jQuery('#platform-section .system-fit-options--bottom.hidden').first().removeClass('hidden');
            jQuery('#platform-section').show();
            localStorage.removeItem('bar-type');
            localStorage.removeItem('bar-size');
          }
            jQuery('.tower-options .tower-type').show();
        if(jQuery('.tower-options .tower-type .bar-option:visible').length <= 1)
            jQuery('.tower-options .tower-type').hide();
          setRequiredItems();
          enableCart();
        }
    });
  
  
    jQuery('.tower-options .bar-option').unbind().click(function () {
        if (!jQuery(this).hasClass('disabled') && !jQuery(this).hasClass('oos')) {
            jQuery(this).siblings().removeClass('selected');
            jQuery(this).addClass('selected');
            var tower = jQuery('.product-name h1').first().text();
            tower = tower.substring(0, tower.indexOf(' ')).toLowerCase();

            if (jQuery(this).hasClass('bar') || jQuery(this).hasClass('outdoorsman')) {
                var barName = jQuery(this).find('h4').first().text();

                var img = '';
                jQuery('.product-media .galleria-carousel .galleria-image.active').removeClass('active');
                if (jQuery(this).find('img').length > 0)
                    img = jQuery(this).find('img').attr('src');
                if (jQuery(this).hasClass('outdoorsman')) {
                    barName = 'RoundBar';
                    img = imagePath + 'roundbar.png';
                    jQuery('.product-media .galleria-stage img').attr('src', imagePath + 'outdoorsman_' + jQuery(this).find('h4').first().text().toLowerCase() + '.png');
                    jQuery('.product-media .galleria-carousel .galleria-image').first().addClass('active').find('img').attr('src', imagePath + 'outdoorsman_' + jQuery(this).find('h4').first().text().toLowerCase() + '.png');
                }
                else if (!isLNL) {
                    jQuery('.product-media .galleria-stage img').attr('src', imagePath + tower + '-' + barName.toLowerCase().replace(' ', '-') + '.png');
                    jQuery('.product-media .galleria-carousel .galleria-image').first().addClass('active').find('img').attr('src', imagePath + tower + '-' + barName.toLowerCase().replace(' ', '-') + '.png');
                }
                jQuery('.system-summary .bar-options').first().addClass('required');
                jQuery('.system-summary .bar-options h4').first().html('<a target="_blank" href="/variants/' + jQuery(this).attr('data-id') + '">' + barName + '</a>');
                if (img.length > 0)
                    jQuery('.system-summary .bar-options img').first().attr('src', img);
                var price = jQuery(this).find('.price').first().text().replace('$', '');
                if (jQuery(this).find('.price').first().attr('data-raw'))
                    price = jQuery(this).find('.price').first().attr('data-raw');

                if (price.length > 0)
                    jQuery('.system-summary .bar-options span.price').first().html(getPriceText(price));
                jQuery('.system-summary .bar-options p a').first().hide();
                loadBarSizes(barName);
                setRequiredItems();
                localStorage.setItem('tower-bartype', jQuery(this).attr('id'));
                enableCart();
            }
            else {
                localStorage.setItem('tower-barsize', jQuery(this).attr('id'));
                if(document.getElementById('thirdTower').checked) {
                  document.getElementById('thirdTower').checked = false;
                    setRequiredItems();
                }
            }
            if (jQuery(this).hasClass('tonneau')) {
                localStorage.setItem('tonneauType', jQuery(this).attr('id'));

                if(jQuery(this).attr('id') != '0')
                {
                  addRelatedProduct(jQuery(this).attr('data-id'), false, null);
                  enableCart();
                setRequiredItems();
                }
              else {
                jQuery('#tower-add-cart').addClass('disabled');

              }
              fitCheck();
            }
            if (jQuery(this).hasClass('length')) {
               var barId = jQuery(this).attr('data-id');
              console.log('barid', barId);
                var barName = jQuery('.tower-options .length.selected span.hidden').first().text();
                jQuery('.system-summary .bar-options h4').first().html('<a target="_blank" href="/variants/' + jQuery(this).attr('data-id') + '">' + barName + '</a>');
                jQuery('.system-summary .bar-options a').attr('href', '/variants/' + jQuery(this).attr('data-id'));
                if (localStorage.getItem('hasTonneau') != 'true' || jQuery('.tonneau-type .tonneau.selected').length > 0)
                    jQuery('#tower-add-cart').removeClass('disabled');
                jQuery('.related-products .details').each(function () {
                    var name = jQuery(this).find('.name').first().text();
                    var sku = jQuery(this).find('.sku').first().text();
                  var handle = jQuery(this).attr('data-handle');
                    if (jQuery(this).attr('data-id') == barId) {
                      console.log('bar selected');
                        jQuery(this).addClass('cart');
                      	jQuery('#selected-bar').attr('data-sku', sku);
                      	jQuery('#selected-bar').attr('data-limoniapps-discountninja-product-handle', handle);
                      jQuery('#selected-bar').addClass('limoniapps-discountninja-cart-item-product-price');

                    }
                    else if (sku == '8001156' || sku == '8001157' || sku == '8001158' || sku == '8001159') {
                        jQuery(this).removeClass('cart');

                    }
                });
            }
            if (jQuery(this).hasClass('attach')) {
                if (jQuery(this).attr('id') == 'attachment-bar') {
                    localStorage.setItem('attach', 'bar');
                    if (localStorage.getItem('fitId') == '0')
                        jQuery('#shopify-section-system-template .product-single').removeClass('hideBars');
                  jQuery('.tower-options .tower-type .bar-option').show();
                  jQuery('.tower-options .tower-type .bar-option.lnl').hide();
                  
                }
                else if (jQuery(this).attr('id') == 'attachment-tower') {
                    localStorage.setItem('attach', 'tower');
                    jQuery('#shopify-section-system-template .product-single').addClass('hideBars');
                  jQuery('.tower-options .tower-type .bar-option').hide();
                  jQuery('.tower-options .tower-type .bar-option.lnl').show();
                  localStorage.removeItem('bar-type');
                  localStorage.removeItem('bar-size');
                }
              else if (jQuery(this).attr('id') == 'attachment-rugged') {
                    localStorage.setItem('attach', 'rugged');
                    jQuery('#shopify-section-system-template .product-single').addClass('hideBars');
                jQuery('.product-single__photos').first().html('<img src="http://d2amiavn18tu8z.cloudfront.net/fmc/ruggedline-lnl.jpg"></img>');
                jQuery('.tower-platform-size').hide();
                  localStorage.removeItem('bar-type');
                  localStorage.removeItem('bar-size');
                  jQuery('.tower-options .tower-type .bar-option').hide();
                  jQuery('.tower-options .tower-type .bar-option.lnl').show();
                }
                  jQuery('.tower-options .tower-type').show();
              if(jQuery('.tower-options .tower-type .bar-option:visible').length <= 1)
                  jQuery('.tower-options .tower-type').hide();
                setRequiredItems();
                enableCart();
            }
          if (jQuery(this).hasClass('fittype')) {
                if(jQuery(this).hasClass('lnl'))
                  localStorage.setItem('towerSystemId', jQuery(this).attr('data-id').replace('fit-', ''));
                else 
                  localStorage.setItem('systemId', jQuery(this).attr('data-id').replace('fit-', ''));
                setRequiredItems();
                enableCart();
            }
            if (jQuery(this).hasClass('truck')) {
                localStorage.setItem('truck-placement', jQuery(this).attr('data-id'));
                localStorage.removeItem('tower-bartype');
                localStorage.removeItem('tower-barsize');
                jQuery('.bar-option.bar.selected').removeClass('selected');

                setCurrentFit();
                hideBars();
                setRequiredItems();
            }    
          calculateTotals();
            towerInventory();
        }
    });
}
function enableCart() {
    var isFlushRail = window.location.href.indexOf('flushbar') > 0 || window.location.href.indexOf('railbar') > 0;
    var isRuggedLine = window.location.href.indexOf('ruggedline') > 0;
    jQuery('#tower-add-cart').removeClass('disabled');
  //  if (jQuery('.product-single.hideBars').length == 0 && jQuery('.tower-bar-length .bar-option.selected').length == 0 && !isFlushRail && !isRuggedLine)
   //     jQuery('#tower-add-cart').addClass('disabled');

  //  if (jQuery('.product-single.hideBars').length > 0 && jQuery('.tower-platform-size .tower-option.selected').length == 0 && !isRuggedLine)
   //     jQuery('#tower-add-cart').addClass('disabled');

  
}
function loadBarSizes(barName) {
 //   jQuery('.tower-options .tower-bar-length').html('').append('<h4>Select Crossbar Length</h4><p><a target="_blank" href="https://yakima.com/pages/choosing-the-right-crossbar-length">Which crossbar length is right for you?</a></p>');
    var cnt = 1;
  console.log('barname', barName);
 // if(barName.indexOf("HD Bar") >= 0)
  //  cnt = 2;
  
    var minBarSize = 0;
    if (localStorage.getItem('crossbarMin'))
        minBarSize = parseInt(localStorage.getItem('crossbarMin'));
  
    jQuery('#bar-sizes').html('').removeClass('hidden');
    jQuery('.related-products .details').each(function () {
        var name = jQuery(this).find('.name').first().text();
        var sku = jQuery(this).find('.sku').first().text();

        var match = name.toUpperCase().indexOf(barName.toUpperCase()) >= 0;
        if (barName.indexOf('JetStream Silver') >= 0 && name.indexOf('JetStream') >= 0 && name.indexOf('Silver') >= 0)
            match = true;
        if (barName.indexOf('JetStream Black') >= 0 && name.indexOf('JetStream') >= 0 && name.indexOf('Black') >= 0)
            match = true;

        if (match == true && name.toUpperCase().indexOf('ADAPTER') < 0 && name.toUpperCase().indexOf('CAP') < 0) {
            var pname = name.replace(barName, "").replace(barName.toUpperCase(), "").replace(" (Pair)", "").replace("JetStream ", "").trim();
          
            var selectedSize = localStorage.getItem('bar-size');
            if (pname.indexOf(' ') >= 0) {
                var splt = pname.split(' ');
                var cls = "";
                var barSize = splt[0];
                var barInches = '';
                if(pname.indexOf('(') > 0)
                  barInches = pname.substr(pname.indexOf('(') + 1, 3);
                if(barSize == 'Bar') barSize = splt[1];
                if (cnt < minBarSize) {
                    cls = " disabled";
                }
                if (selectedSize != null && selectedSize == barInches) {
                    cls = 'selected';
                }

              
                jQuery('#bar-sizes').append('<div class="system-fit-options--option ' + cls + '">' + barInches + '</div>');
              
              //  jQuery('.tower-options .tower-bar-length').append('<div id="barsize-' + jQuery(this).attr("data-id") + '" class="bar-option length' + cls + '" data-id="' + jQuery(this).attr("data-id") + '" data-sku="' + sku + '">' + violator + '<h2>' + barInches + '</h2><h4>' + barSize + '</h4><span class="hidden">' + name + '</span></div>');
                cnt = cnt + 1;
            }
        }
    });
    if (cnt == 1)
        jQuery('#tower-add-cart').removeClass('disabled');
    bindOptionSelect();
  
    towerInventory();

}
function setRequiredItems() {
    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var isLNL = window.location.href.indexOf('locknload') > 0 || window.location.href.indexOf('ruggedline') > 0;
    var isRuggedLine = window.location.href.indexOf('ruggedline') > 0 || (localStorage.getItem('attach') && localStorage.getItem('attach') == 'rugged');
    var optionalThird = false;
  var conditionalNote = '';
    if (localStorage.getItem('towerSystemId') && localStorage.getItem('attach') == 'tower')
        activeFit = localStorage.getItem('towerSystemId');
    if (localStorage.getItem('systemId') && localStorage.getItem('attach') != 'tower')
        activeFit = localStorage.getItem('systemId');
  if (localStorage.getItem('ruggedSystemId') && localStorage.getItem('attach') == 'rugged')
        activeFit = localStorage.getItem('ruggedSystemId');
  
    localStorage.setItem('fitId', activeFit);

    jQuery('.section.required-items').html('');
    jQuery('.section.conditional-items').html('');

console.log('activefit', activeFit);
    if (activeFit && activeFit > 0) {

        var url = apiUrl + '/component/GetComponents/US/' + activeFit + '/0/0/false/true';
        if (isLNL && localStorage.getItem('attach') == 'bar')
            url = apiUrl + '/component/GetComponents/US/' + activeFit + '/0/0/true/true';
        if (isLNL && jQuery('.product-single.hideBars').length == 0)
            url = apiUrl + '/component/GetComponents/US/' + activeFit + '/0/0/false/true/true'

        console.log(url);
        jQuery.get(url, function (data) {
            console.log(data);
            jQuery('.related-products .details.cart').removeClass('cart').removeAttr('data-qty');
         //   addRelatedProduct("*", false, null);
            jQuery('.tower-options .tower-option .pill.red').removeClass('red').addClass('yellow').text('Unverified');
            jQuery('.tower-options .system-summary .required-items').html('');
          
            jQuery('#platform-section .system-fit-options--option').removeClass('selected').removeClass('disabled').addClass('hidden');
          jQuery('#thirdTower').unbind();
          jQuery('#towerCount').hide();
            var hasPlatform = false;
            var matchFound = false;
            jQuery.each(data, function (i, e) {
              conditionalNote = e.conditionalNote;
              
               if(e.sku == 'NOLNL')
                    {
                      jQuery('#attachment-bar').removeClass('selected').addClass('disabled');
                      if(!jQuery('#attachment-tower').hasClass('disabled'))
                        jQuery('#attachment-tower').trigger( "click" );
                    }
              console.log('checking ', e.sku, isLNL);
                if (typeof e.sku !== 'undefined' && ((e.roleId !== 6 && e.roleId !== 7) || (isLNL && ((e.sku.indexOf('800504') == 0 && e.sku.indexOf('8005042') < 0) || e.sku.indexOf('8005063') == 0 || e.sku.indexOf('8005066') == 0))) && (!isLNL || localStorage.getItem('fitId') == '0' || jQuery('.product-single.hideBars').length == 0 || e.roleId > 3 || e.roleId == 1 || localStorage.getItem('attach') == 'rugged' || window.location.href.indexOf('ruggedline') > 0)) {
                    var psku = e.sku;
                   console.log('adding sku', psku);
                    if ((psku.indexOf('800504') == 0 && e.roleId != 8) || psku.indexOf('8005063') == 0) {
                        hasPlatform = true;
                        if (localStorage.getItem('platformSize') && localStorage.getItem('attach') == 'crossbar')
                            psku = localStorage.getItem('platformSize');
                      
                        jQuery('#platform-section .system-fit-options--option').each(function () {
                            var sku = jQuery(this).attr('data-sku');
                            if (sku.indexOf(e.sku) == 0) {
                              matchFound = true;
                              console.log('set platform to ', sku);
                              jQuery(this).addClass('selected').removeClass('hidden');
                              localStorage.setItem('platformSize', sku);
                            }
                            else if(isRuggedLine || localStorage.getItem('attach') == 'tower') {
                                //RuggedLine can only work on the called size
                                matchFound = false;
                            }
                          
                           
                            if(!matchFound)
                              jQuery(this).addClass('hidden');
                              
                        });
                        enableCart();
                        
                        console.log('adding related', e);
                          addRelatedProduct(psku, false, conditionalNote);
                       if(isRuggedLine || localStorage.getItem('attach') == 'tower') {
                                //RuggedLine can only work on the called size
                                jQuery('#platform-section').hide();
                            }
                      else {
                                jQuery('#platform-section').show();
                      }
                          
                    }
                    else {
                      if(e.roleId == 15 || e.roleId == 16){
                        console.log('Optional third tower');
                        optionalThird = true;
                        jQuery('#towerCount').show();
                        jQuery('#thirdTower').change(function() {
                            if(this.checked) {
                              addRelatedProduct(e.sku, true, "");
                              if(localStorage.getItem('tower-barsize') && localStorage.getItem('tower-barsize').length > 0) {
                                  addSingleBar(jQuery('#' + localStorage.getItem('tower-barsize')).first().attr('data-sku'));
                              }
                              else if(jQuery('.required-items .sku8005042').length == 2) {
                                     addRelatedProduct("8005042", true, "");
                              }
                            }  
                          else 
                            { 
                              window.location.reload();
                            }
                          
                        });
                      }
                      else if (e.sku.indexOf('8005042') < 0) {
                        if(e.sku.indexOf('800506') == 0 || e.sku.indexOf('8005070') == 0)
                          addRelatedProduct(e.sku, false, conditionalNote);
                        else
                          addRelatedProduct(e.sku, true, conditionalNote);
                          
                      }
                    }
                }
              
            });
          setCrossbar();
            if (isLNL) {
                if (localStorage.getItem('platformSize') && !hasPlatform) {
                    var psku = localStorage.getItem('platformSize');

                    addRelatedProduct(psku, false, conditionalNote);
                }
              console.log('adding lnl clamps');
                if (localStorage.getItem('attach') == 'bar' && localStorage.getItem('platformSize') != null && localStorage.getItem('platformSize').indexOf('80050') == 0) {
                    addRelatedProduct('8005039', true, null);
                    addRelatedProduct('8005039', true, null);
                }
              else if (localStorage.getItem('attach') == 'tower' && localStorage.getItem('platformSize') != null && localStorage.getItem('platformSize').indexOf('80050') == 0) {
                
                    addRelatedProduct('8005042', true, null);
                    addRelatedProduct('8005042', true, null);
                }
                fitCheck();
            }
            

            

            var tonneauKit = jQuery('.tonneau-type .tonneau.selected').first().attr('data-id');
          if(tonneauKit != null && tonneauKit.length > 0) {
            if (localStorage.getItem('isTruck') == 'true' && localStorage.getItem('hasTonneau') == 'true') {
                addRelatedProduct(tonneauKit, false, null);
              if(jQuery('.tonneau-type .tonneau.selected h4').first().text() == 'Diamondback w/out tracks')
                addRelatedProduct('8001634', false, null);
            }
            else if (localStorage.getItem('isTruck') == 'true' && (localStorage.getItem('make-name') == 'Toyota' || localStorage.getItem('make-name') == 'Nissan') && (currentSku.indexOf('overhaul') >= 0 || currentSku.indexOf('outpost') >= 0)) {
      //          addRelatedProduct('8001168', false, null);
            }
          }

            if(localStorage.getItem('tower-barsize') != null) {
              jQuery('.related-products .details').each(function () {
                    if (jQuery(this).attr('data-id') == localStorage.getItem('tower-barsize').replace('barsize-', '')) {
                        jQuery(this).removeClass('cart').addClass('cart');
                    }
                });
            }    
          calculateTotals();
          
        });
        conditionalNote = "";


    }


}
function setCrossbar() {
  jQuery('.related-products .details').each(function () {
      var bars = 'jetstream,hd-bar,roundbar,corebar';
    var barType = jQuery('#bar-types .selected').text();
    if(barType == null || barType.length == 0) barType = 'HD Bar';
      if(bars.indexOf(jQuery(this).attr('data-handle')) >= 0) {
        var barName = jQuery(this).find('.name').text();
        jQuery(this).removeClass('cart');
          if(jQuery('.product-single.hideBars').length == 0) {
            if (barType.length > 0 && barName.indexOf(barType) >= 0) {
              if (barType != 'JetStream' || barName.indexOf(jQuery('#bar-colors .selected').text()) >= 0) {
                if (jQuery('#bar-sizes .selected').text().length > 0 && barName.indexOf(jQuery('#bar-sizes .selected').text()) >= 0) {
                  jQuery(this).addClass('cart');
                  addRelatedProduct(jQuery(this).find('.sku').text(), false, null);
                }
              }
            }
          }
      }
      if(jQuery(this).attr('data-handle') == 'roundbar-sl-adapter') {
        jQuery(this).removeClass('cart');
        if(barType == 'RoundBar') jQuery(this).addClass('cart');
      }
    if(jQuery(this).attr('data-handle') == 'hd-bar-sl-adapter' && localStorage.getItem('attach') != 'tower' && localStorage.getItem('attach') != 'rugged') {
        jQuery(this).removeClass('cart');
        if(barType == 'HD Bar') jQuery(this).addClass('cart');
      }
    });
   loadSummary();
}
function setPlatform() {
  jQuery('.related-products .details').each(function () {
      var selectedSize = jQuery('#platform-section .system-fit-options--option.selected').text().replaceAll('"', '');
      if(jQuery(this).attr('data-handle') == 'locknload-platform') {
        var platformName = jQuery(this).find('.name').text();
        jQuery(this).removeClass('cart');
          if (selectedSize.length > 0 && platformName.indexOf(selectedSize) >= 0) {
                jQuery(this).addClass('cart');
                addRelatedProduct(jQuery(this).find('.sku').text(), false, null);

          }
      }
    });

   setRequiredItems();
   loadSummary();
}
function addRelatedProduct(findSku, allowDupes, conditionalNote) {
  var addToCart = true;
      console.log('add related ', findSku);
    jQuery('.related-products .details').each(function () {
        var sku = jQuery(this).find('.sku').first().text();
      var handle = jQuery(this).attr('data-handle');
        if (sku.indexOf('8001168') >= 0 && localStorage.getItem('hasTonneau') == 'true') {
            //Don't Add Bed Track Kit if truck has Tonneau
        }
        else {
            if (sku.indexOf(findSku) >= 0) {
                if ((jQuery('.section.required-items .required.sku' + sku).length == 0 && jQuery('.section.conditional-items .required.sku' + sku).length == 0) || allowDupes) {
                  	var pricePrefix = '';
                    if(localStorage.getItem('ipCountry') == 'ca')
                      pricePrefix = 'ca';
                    var priceText = getPriceText(jQuery(this).find('.' + pricePrefix + 'price').first().text().replace('.0000', '').replace('.9900', '.99'));

                    if(conditionalNote != null && conditionalNote != '0' && conditionalNote.length > 0) {
                      jQuery('.tower-options .system-summary #system-conditionals').show();
                        jQuery('.tower-options .system-summary #system-conditionals .conditional-items').append('<div class="required sku' + sku + '" data-sku="' + sku + '" data-id="' + jQuery(this).attr('data-id') + '" data-limoniapps-discountninja-product-handle="' + handle + '"><span class="conditional-note">' + conditionalNote + '</span><a target="_blank" href="' + jQuery(this).find('.url').first().text() + '"><img src="' + jQuery(this).find('.img').first().text() + '"/><h4>' + jQuery(this).find('.name').first().text() + '</h4></a><input type="checkbox" class="addToCart"/><span class="addText">Add To Cart</span><span class="price limoniapps-discountninja-productprice">' + priceText + '</span><p></p></div>');
                        jQuery('.addToCart').change(function() { addConditional(sku); });
                        addToCart = false;
                    }
                    else
                      jQuery('.tower-options .system-summary .required-items').append('<div class="required sku' + sku + '" data-sku="' + sku + '" data-id="' + jQuery(this).attr('data-id') + '"  limoniapps-discountninja-cart-item-product-price data-limoniapps-discountninja-product-handle="' + handle + '"><a target="_blank" href="' + jQuery(this).find('.url').first().text() + '"><img src="' + jQuery(this).find('.img').first().text() + '"/><h4>' + jQuery(this).find('.name').first().text() + '</h4></a><span class="qty">Qty:1</span><span class="price limoniapps-discountninja-productprice">' + priceText + '</span><p></p></div>');
                }
              
              if(addToCart) {
                if (!jQuery(this).hasClass('cart') || allowDupes) {
                    if (jQuery(this).hasClass('cart')) {
                        if (jQuery(this).attr('data-qty') && jQuery(this).attr('data-qty') == '2')
                            jQuery(this).attr('data-qty', '3');
                        else
                            jQuery(this).attr('data-qty', '2');
                    }
                    else {

                        jQuery(this).addClass('cart');
                    }
                }
              }
              else { 
                  jQuery(this).removeClass('cart');
               }
            }
        }
    });
}
function loadSummary() {
    jQuery('.tower-options .system-summary .required-items').html('');
    jQuery('#out-of-stock .oos-parts').html('');
    jQuery('.related-products .details.cart').each(function () {
        var sku = jQuery(this).find('.sku').first().text();
        var handle = jQuery(this).attr('data-handle');
        var pricePrefix = '';
        if(localStorage.getItem('ipCountry') == 'ca')
          pricePrefix = 'ca'; 
        var qty = '1';
        if(jQuery(this).attr('data-qty')) qty = jQuery(this).attr('data-qty');
        var price = jQuery(this).find('.' + pricePrefix + 'price').first().text().replace('.0000', '').replace('.9900', '.99');
        var priceText = getPriceText(jQuery(this).find('.' + pricePrefix + 'price').first().text().replace('.0000', '').replace('.9900', '.99'));

       if(jQuery('.tower-options .system-summary .required-items .sku' + sku).length == 0) {
          jQuery('.tower-options .system-summary .required-items').append('<div class="required sku' + sku + '" data-sku="' + sku + '" data-id="' + jQuery(this).attr('data-id') + '"  limoniapps-discountninja-cart-item-product-price data-limoniapps-discountninja-product-handle="' + handle + '"><a class="pdp-link" target="_blank" href="' + jQuery(this).find('.url').first().text() + '"><img src="' + jQuery(this).find('.img').first().text() + '"/><h4>' + jQuery(this).find('.name').first().text() + '</h4></a><span class="qty">Qty:' + qty + '</span><span class="price limoniapps-discountninja-productprice">' + priceText + '</span></div>');
       }
    });
    window.setTimeout(function() {
      summaryInventory();
      calculateTotals();
    }, 1000);
}
function addSingleBar(sku) {
  var jsb_sku = new Array("0425","0426","0427");
  var jss_sku = new Array("0428","0429","0430");
  var hd_sku = new Array("1156","1157","1158","1159");
  var cb_sku = new Array("0421","0422","0423","0424");
  var rb_sku = new Array("0408","0409","0410","0411","0420");

  var jsb_id = new Array("30386395414576","30386397610032","30386398101552");
  var jss_id = new Array("30386398593072","30386399019056","30386399313968");
  var hd_id = new Array("32047525888048","32047527690288","32047528345648","32047529754672");
  var cb_id = new Array("30386395709488","30386399379504","30386399445040","30386399477808");
  var rb_id = new Array("32047515664432","32047516352560","32047518580784","32047519498288","32047519498288");

  var price = 0;
  var caprice = 0;
  var img = "";
  var vid = "";
  var name = "";
  
  ss = sku.substring(3);
  if(jsb_sku.includes(ss)) {
    price = 145;
    caprice = 185.99;
    img = "https://yakima-production.s3.amazonaws.com/fmc/jetstream-black.png";
    vid = jsb_id[jsb_sku.indexOf(ss)];
    name = "JetStream Black Single Bar";
  }
  if(jss_sku.includes(ss)) {
    price = 145;
    caprice = 185.99;
    img = "https://yakima-production.s3.amazonaws.com/fmc/jetstream-silver.png";
    vid = jss_id[jss_sku.indexOf(ss)];
    name = "JetStream Silver Single Bar";
  }
  if(hd_sku.includes(ss)) {
    price = 170;
    caprice = 217.99;
    img = "https://yakima-production.s3.amazonaws.com/fmc/hdbar.png";
    vid = hd_id[hd_sku.indexOf(ss)];
    name = "HD Bar Single Bar";
  }
  if(cb_sku.includes(ss)) {
    price = 110;
    caprice = 140.99;
    img = "https://yakima-production.s3.amazonaws.com/fmc/corebar.png";
    vid = cb_id[cb_sku.indexOf(ss)];
    name = "CoreBar Single Bar";
  }
  if(rb_sku.includes(ss)) {
    price = 75;
    caprice = 96.99;
    img = "https://yakima-production.s3.amazonaws.com/fmc/roundbar.png";
    vid = rb_id[rb_sku.indexOf(ss)];
    name = "RoundBar Single Bar";
  }
  var rtn = "<div id=\"thirdbar\" class=\"details cart\" data-id=\"" + vid + "\"><span class=\"sku\">9999999</span><span class=\"name\">" + name + "</span><span class=\"price\">" + price + "</span><span class=\"caprice\">" + caprice + "</span><span class=\"img\">" + img + "</span><span class=\"url\">/variants/" + vid + "</span></div>";
  jQuery('.related-products #thirdbar').remove();
  jQuery('.related-products').first().append(rtn);
 addRelatedProduct("9999999", false, "");
  console.log(rtn);
}
function addConditional(addSku) {
  
    jQuery('.related-products .details').each(function () {
        var sku = jQuery(this).find('.sku').first().text();
        if(sku == addSku) {
          var chkAdd = jQuery('.conditional-items .sku' + sku + ' .addToCart').first();
          if(jQuery(chkAdd).is(':checked'))
            jQuery(this).addClass('cart');
          else
            jQuery(this).removeClass('cart');

        }
    });
    calculateTotals();
}
function calculateTotals() {
    var total = 0;
    var discountTotal = 0;
    jQuery('.system-summary .required-items .price').each(function () {
        var chkAdd = jQuery(this).siblings('input.addToCart');
        if(!chkAdd.length || jQuery(chkAdd).is(':checked')) {
          if (jQuery(this).text().length > 0 && jQuery(this).text() != 'Out of Stock' && jQuery(this).parent().css('display') !== 'none') {
            var lineprice = 0;
      
            lineprice =  parseFloat(jQuery(this).text().replace('$', '').replace(',', ''));
            var qty = 1;
            qty = jQuery(this).siblings('span.qty').html().replace('Qty:', '');
            total = total + (lineprice * qty);
            if( jQuery(this).find('span.money').length) {
            //console.log('discount price', jQuery(this).find('span.money').text().replace('$', ''));
            discountTotal = discountTotal + parseFloat(jQuery(this).find('span.money').text().replace('$', '').replace(',', ''));
            }
          }
        }
    });
  
    jQuery('.system-summary .totalprice').first().html(getPriceText(total));
  calculateDiscounts();
}
function calculateDiscounts() {
  var discountTotal = 0;
  jQuery('.system-summary span.limoniapps-discountninja-shortcode-discounted_price span.limoniapps-discountninja-money span.money').each(function () {
        
            var lineprice = 0;

            lineprice =  parseFloat(jQuery(this).text().replace('$', ''));
            discountTotal = discountTotal + lineprice;
         //   console.log('discount price', jQuery(this).text().replace('$', ''));
      jQuery('.system-summary .totalprice').first().html(getPriceText(discountTotal));
    });
}

function addToCart() {
    if (!jQuery('#tower-add-cart').hasClass('disabled')) {

        var store = '';
      var productName =  $('.product-single__title').first().text();
      var totalPrice =   parseFloat($('.system-total .totalprice').first().text().replace('$', '').replace(',', ''));
      
        if (window.location.href.indexOf('/ca') > 0)
            store = '/ca';
      
		jQuery('#tower-add-cart')
          .css('background-color', '#666')
          .find('span')
          .text('Added');

      dataLayer.push({
                ecommerce: null
            }); 
            
            dataLayer.push({
                event: "gtmEcommerceEvent",
                eventName: "add_system_to_cart",
                eventCategory: "ecommerce",
                eventAction: "add system to cart",
                eventLabel: productName,
                nonInteractionHit: false,
                ecommerce: {
                    items: [{
                        item_id: currentSku,
                        item_name: productName,
                        affiliation: "Yakima Store",
                        coupon: null, 
                        currency: "USD",
                        discount: 0,
                        item_brand: "Yakima",
                        item_category: null, 
                        item_category2: null, 
                        item_category3: null, 
                        item_category4: null, 
                        item_category5: null, 
                        item_variant: "Default",
                        price: totalPrice,
                        quantity: 1
                    }]
                }
            });
      var cartItems = [];
        jQuery('.system-summary .required-items .required').each(function (idx) {
          
        var sku = jQuery(this).attr('data-sku');
        var name = jQuery(this).find('h4').first().text();
        var price = parseFloat(jQuery(this).find('.price').text().replace('$', '').replace(',', ''));

          idx = idx++;
          var qty = 1;
  console.log('adding ' + jQuery(this).attr('data-id'));
          if(jQuery(this).find('span.qty').length > 0);
            qty = parseFloat(jQuery(this).find('span.qty').first().text().replace('Qty:', ''));
        //   addProduct(jQuery(this).attr('data-id'), qty, idx);
          cartItems.push({ 'id': jQuery(this).attr('data-id'), 'quantity': qty });
          
            dataLayer.push({
                ecommerce: null
            }); 
            
            dataLayer.push({
                event: "gtmEcommerceEvent",
                eventName: "add_system_to_cart",
                eventCategory: "ecommerce",
                eventAction: "add system to cart",
                eventLabel: name,
                nonInteractionHit: false,
                ecommerce: {
                    items: [{
                        item_id: sku,
                        item_name: name,
                        affiliation: "Yakima Store",
                        coupon: null, 
                        currency: "USD",
                        discount: 0,
                        item_brand: "Yakima",
                        item_category: null, 
                        item_category2: null, 
                        item_category3: null, 
                        item_category4: null, 
                        item_category5: null, 
                        item_variant: "Default",
                        price: price,
                        quantity: qty
                    }]
                }
            });
          
            localStorage.setItem('fitId', activeFit);
            localStorage.setItem('system-name', jQuery('.product-single__title').first().text().replace(' System', ''));

            if (('partnerId' in localStorage && localStorage.getItem('partnerId') !== 'null') || localStorage.getItem('ipCountry') == 'ca') {

                var cart = '';
                if (localStorage.getItem('cart-transfer'))
                    cart = localStorage.getItem('cart-transfer');

                if(localStorage.getItem('ipCountry') == 'ca')
                  price = jQuery(this).find('.caprice').text();
                localStorage.setItem('cart-transfer', cart + '|' + sku + ',1,' + price + ',' + name);
				SetCartCount();
            }

        });
        
        dataLayer.push({
            'event': 'fmcFitSelect',
            'action': 'new',
            'fmcFitId': '' + activeFit
        });

        var container = '<div id="fmc-modal-container" class="ajax-success-message modal-container active reversed"><div class="ajax-success-message modal-content"><div class="content">';
        var reload = true;
      if(jQuery('.system-summary .required.oos').length > 0) {
          var oosProducts = '';
          jQuery('.system-summary .required.oos').each(function () {
                oosProducts += '<br/>' + jQuery(this).find('h4').text() + ' (' + jQuery(this).attr('data-sku') + ')';
                var vid = jQuery(this).find('a').first().attr('href').replace('/variants/', '');
                for (var i = 0; i < cartItems.length; i++) 
                { 
                  if(cartItems[i].id == vid)   cartItems[i].quantity = 0;
                  console.log('removing OOS ', vid); 
                }
      		});
            reload = false;
        	jQuery('body').first().append(container + '<p>Not all products can be added to your cart at this time - please find these products at your local dealer to complete your Yakima System<br/>' + oosProducts + '</p><div class="actions"><a onclick="reloadPage();" class="button reversed close">I Understand</a></div></div></div>');
      }
      if(cartItems.length > 0) {
            let cartItemList = { 'items': cartItems };
            console.log(cartItemList);
            addProducts(cartItemList, reload);
        }
      //  else if ('partnerId' in localStorage && localStorage.getItem('partnerId') !== 'null')
    //        jQuery('body').first().append(container + '<h4 class="title">PRODUCTS HAVE BEEN ADDED TO YOUR CART</h4>We\'ve brought all of your products together so you can easily checkout. We hope you enjoy your next adventure with your Yakima products!</p><div class="actions"><a class="button reversed close" href="#" onclick="location.reload();">Continue Shopping</a></div></div></div>'); 
     //  else
         //   jQuery('body').first().append(container + '<h4 class="title">PRODUCTS HAVE BEEN ADDED TO YOUR CART</h4>We\'ve brought all of your products together so you can easily checkout. We hope you enjoy your next adventure with your Yakima products!</p><div class="actions"><a class="button reversed close" href="#" onclick="location.reload();">Continue Shopping</a><a href="/checkout" class="button reversed outline">Review And Checkout</a></div></div></div>'); 


    }

}

function addProducts(cartItems, reload) {
  //  var formData = "{ 'items': [{ 'id': 30947596533808, 'quantity': 1 },{ 'id': 40730529169456, 'quantity': 1 },{ 'id': 32241234739248, 'quantity': 1 },{ 'id': 32241235132464, 'quantity': 1 }] }";
 console.log(JSON.stringify(cartItems));
 
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartItems)
    })
    .then(response => {
      if(reload)
         window.location = window.location.href + '?showCart=1';
      return response.json();
    })
    .catch((error) => {
      console.log('Error:', error);
    });
}
function addProduct(id, qty, idx) {
  window.setTimeout(function() {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: qty,
        id: id
      },
      dataType: 'json',
      success: function () {
        console.log('Product added to cart: ' + id);
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr);
      }

    });  
  }, (idx + 1) * 150);
}
function callAjax(url, failCnt) {
    console.log(url);
    new Ajax.Request(url, {
        method: 'post',
        onFailure: function (response) {
            failCnt++;
            if (failCnt > 5)
                alert('Ajax call failed: ' + url);
            else
                callAjax(url, failCnt);
        }
    });
}